/* assets/src/viewer/core/renderer.js
 * WebGLRenderer modernizzato r160:
 *  - ColorManagement attivo, outputColorSpace = SRGB
 *  - ACESFilmicToneMapping (prima era NoToneMapping)
 *  - illuminazione fisica di default (niente physicallyCorrectLights legacy)
 *  - pixelRatio cap adattivo, shadow map PCFSoft on-demand
 */
import * as THREE from 'three';
import { getViewerSettings, isMobileViewer, pixelRatioCap } from '../settings.js';

// Color management globale (default true in r160, esplicito per chiarezza/intento).
THREE.ColorManagement.enabled = true;

export function createRenderer(container) {
  const settings = getViewerSettings();
  const mobile = isMobileViewer();

  const bounds = container.getBoundingClientRect();
  const width = Math.max(bounds.width || container.clientWidth || 1, 1);
  const height = Math.max(bounds.height || container.clientHeight || 1, 1);

  const renderer = new THREE.WebGLRenderer({
    antialias: !mobile && settings.antialias,
    alpha: true,
    // true: con render ON-DEMAND la canvas conserva l'ultimo frame quando il browser ricompone
    // senza un nuovo render (niente flicker), e rende toDataURL affidabile in qualsiasi momento (PDF).
    preserveDrawingBuffer: true,
    powerPreference: 'high-performance',
  });
  if (renderer.debug) renderer.debug.checkShaderErrors = false;

  renderer.setSize(width, height, false);
  renderer.setPixelRatio(pixelRatioCap());
  renderer.autoClear = false;

  renderer.shadowMap.enabled = mobile ? false : settings.shadows;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.shadowMap.autoUpdate = false;
  renderer.shadowMap.needsUpdate = true;

  // API colore/tono moderne (r152+).
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  // ACES comprime le alte luci: l'esposizione utile è ~1.0; manteniamo il setting white-label.
  renderer.toneMappingExposure = settings.exposure || 1.0;
  renderer.sortObjects = true;

  container.appendChild(renderer.domElement);
  return renderer;
}
